import { Box, styled } from '@mui/material';

export const MuiTextAccordionContainer = styled(Box)({
  padding: '16px 0',
  width: '100%',
  cursor: 'pointer',
});
